export default __webpack_public_path__ + "static/reed-4--mobile-a17c358a1f6bb66fb80527ca58d567c1.png";